import React, { Component } from 'react'
import Termsconditions from './Termsconditions'
import Expiredlink from './Expiredlink'
//import config from 'react-global-configuration';
import axios from 'axios';
import querystring from 'query-string';
import { BallClipRotate } from 'react-pure-loaders';
//import dev from '../Config/dev.js'
import {
  BrowserRouter as Router,
  Redirect
} from 'react-router-dom';
import Route from 'react-router-dom/Route'

class Validate extends Component {

  constructor(props) {
    super(props)

    this.state = {
      linkStatus: '',
      clientID: '',
      payeeEmail: '',
      payeeName: '',
      entityName: '',
      requestID: '',        
      loading: true,
    }

  }

  componentDidMount() {
    this.setState({ loading: true });
    const RID = querystring.parse(this.props.location.search) 
    const authCode=RID.RID;  

    //Clear localStorage from browser. 
    localStorage.setItem('A-Token', "");
    localStorage.setItem('clientID', "");
    localStorage.setItem('entityName', "");
    localStorage.setItem('payeeEmail', "");
    localStorage.setItem('payeeName', "");
    localStorage.setItem('requestID', "");
    
    // Authentication using Auth Code - AON Start
   const AuthStr = 'A-Token '.concat(authCode); 
   const authAxios = axios.create({  
    baseURL: axios.defaults.authURL,
    headers: {         
        'Authorization': AuthStr
    },
   });
   // Authentication using Auth Code - AON End

    const URL='Token/AuthenticateAuthCode?MFACode=&sendotp=false'  
    authAxios.post(URL)   
      .then(response => {  
        debugger;      
        this.setState({ linkStatus: response.data.IsValid })
        this.setState({ clientID: response.data.ClientID })
        this.setState({ payeeEmail: response.data.PayeeEmail })
        this.setState({ payeeName: response.data.PayeeName })
        this.setState({ entityName: response.data.FXOEntityName })
        this.setState({ requestID: RID.RID });
        this.setState({ loading: false });
        localStorage.setItem('A-Token', RID.RID);
      }).catch(function (error) {
        console.log(error);
      })
  }

  render() {   
    return (

      <>
        {this.state.loading === true ? <div class="overlay"> </div> : ''}
        <BallClipRotate color={'#123abc'} loading={this.state.loading} />
        {
          (this.state.linkStatus === false) ? (
            < Redirect to="/Expiredlink" />
            // <Expiredlink/>
          ) : null

        }
        {
          (this.state.linkStatus === true && this.state.payeeName != '' && this.state.requestID != '') ? (

            <Redirect
              push
              to={{
                pathname: "/Termsconditions",
                state: {
                  payeeName: this.state.payeeName,
                  entityName: this.state.entityName,
                  clientID: this.state.clientID,
                  payeeEmail: this.state.payeeEmail,
                  requestID: this.state.requestID

                }
              }}
            />

          ) : null

        }
      </>
    )


  }
}

export default Validate
